import { render, staticRenderFns } from "./AdminStudyGroupIndex.vue?vue&type=template&id=6c7f6a88&"
import script from "./AdminStudyGroupIndex.vue?vue&type=script&lang=js&"
export * from "./AdminStudyGroupIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports